import { useEffect, useState } from 'react';

// ----------------------------------------------------------------------
// Forca um re-render periodico. Usado para manter textos relativos
// (ex: "há 5 min") corretos sem depender de uma nova mensagem chegar.

export default function useTick(intervalMs = 30000) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);
}
